import React, {ReactNode} from 'react';

import cs from 'classnames';
import {Link} from 'react-router';
import styled from 'styled-components';

import {styledMediaQuery} from 'app/general/mediaqueries';
import {UserContentContainer} from 'app/general/structures/UserContentContainer';
import {getContentType} from 'app/utils/content-type';
import {getObjectName} from 'app/utils/fallbacks';
import {stripHTML} from 'app/utils/strings';

import {LazyTooltip} from '../LazyTooltip';

import {ContentType} from 'sweet-types';

interface Props {
  name: string;
  contentType: ContentType;
  url: string;
  actionsButton: ReactNode;
  thumbnail?: string;
  description?: string;
}

export function GenericWidget({
  name,
  contentType,
  url,
  actionsButton,
  thumbnail,
  description = '',
}: Props) {
  const ct = getContentType(contentType);
  const tooltipIsEmpty = !stripHTML(description).trim();
  return (
    <StyledResponsiveCard>
      <div className="card">
        <LazyTooltip
          tooltip={<UserContentContainer content={description} />}
          hide={tooltipIsEmpty}
        >
          <div>
            <Link to={url} className="text-decoration-none">
              <div className="card-body p-0">
                <StyledBigImage thumbnail={thumbnail}>
                  <i className={cs(ct.icon, {'d-none': thumbnail})} />
                </StyledBigImage>
              </div>
            </Link>
            <div className="card-footer d-flex justify-content-between align-items-center">
              <Link to={url} className="text-dark font-weight-bold">
                <i className={cs('mr-2', ct.icon)} />
                {getObjectName(name, ct.name, true)}
              </Link>
              {actionsButton}
            </div>
          </div>
        </LazyTooltip>
      </div>
    </StyledResponsiveCard>
  );
}

export const StyledResponsiveCard = styled.div`
  flex: 1 1 100%;
  min-width: 250px;
  max-width: 100%;
  margin-bottom: 1rem;

  ${styledMediaQuery.only('sm')`
    max-width: 48%;
  `}

  ${styledMediaQuery.only('md')`
    max-width: 30%;
  `}

  ${styledMediaQuery.only('lg')`
    max-width: 20%;
  `}

  ${styledMediaQuery.only('xl')`
    max-width: 15%;
  `}
`;

const StyledBigImage = styled.div.attrs({
  className:
    'd-flex align-items-center justify-content-center text-weight-normal text-light',
})<{thumbnail?: string}>`
  font-size: 5em;
  width: 100%;
  overflow: hidden;
  height: 150px;
  background-image: ${({thumbnail}) =>
    thumbnail ? `url(${thumbnail})` : 'none'};
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center;
`;
